// Icons for LinkedIn, GitHub, and LeetCode
export const socialLinks = [
    { id: 'linkedin', linkURL: 'https://www.linkedin.com/in/shivam-patel-066', imgSrc: '/assets/social/linkedin' },
    { id: 'github', linkURL: 'https://github.com/shivampatel066', imgSrc: '/assets/social/github' },
    { id: 'leetcode', linkURL: 'https://leetcode.com/u/shivampatel066/', imgSrc: '/assets/social/leetcode' },
    { id: 'medium', linkURL: 'https://medium.com/@shivampatel066', imgSrc: '/assets/social/medium' }
];